declare namespace $ {

	type $mol_view_tree2_to_js_test_ex_array_boolean_foo_bar__1 = $mol_type_enforce<
		false
		,
		boolean
	>
	type $mol_view_tree2_to_js_test_ex_array_boolean_foo_bar__2 = $mol_type_enforce<
		true
		,
		boolean
	>
	export class $mol_view_tree2_to_js_test_ex_array_boolean_foo extends $mol_object {
		bar( ): readonly(boolean)[]
	}
	
}

//# sourceMappingURL=array_boolean.view.tree.d.ts.map